export default __webpack_public_path__ + "static/Alen-7777850466389cfbf97e484666d31398.jpeg";